export const memberShipOptions = [
  { label: 'Sepa', value: 'sepa' },
  { label: 'Creditcard', value: 'creditcard' },
];

export const classOptions = [
  { label: 'iDeal', value: 'ideal' },
  { label: 'Creditcard', value: 'creditcard' },
];
